/**
 * Endpoints for the dashboard's news / academy / announcements section.
 *
 * News and academy are EXTERNAL public WordPress APIs — absolute URLs, no auth
 * headers. Do not route these through the main Rabex API base query.
 *
 * Announcements are DIFFERENT: they are served by rtc on our own origin, so the
 * path is relative and goes through the api slice's baseQuery (auth headers,
 * token refresh, error handling all come for free).
 *
 * Used by: services/newsAndAcademy
 */

export const RABEX_BASE_URL = 'https://rabex.ir';

export const NEWS_API_PATH = '/news/wp-json/rabex/v1/latest-news';
export const ACADEMY_API_PATH = '/academy/wp-json/rabex/v1/latest-articles';

/** Full URLs — exposed for use outside RTK Query if ever needed (e.g. SSR). */
export const NEWS_API_URL = `${RABEX_BASE_URL}${NEWS_API_PATH}`;
export const ACADEMY_API_URL = `${RABEX_BASE_URL}${ACADEMY_API_PATH}`;

/**
 * rtc announcements — relative path, same origin as every other /api/v1 route.
 * GET returns one page of PUBLISHED announcements, newest first. Scheduled rows
 * (publishedAt in the future) are invisible here, in the page and in `total`.
 */
export const ANNOUNCEMENTS_API_PATH = '/api/v1/rtc/announcements';

/**
 * Page size for the announcements feed. The server defaults to 20 and rejects
 * anything above 100 with a 400 rather than clamping it.
 */
export const ANNOUNCEMENTS_PAGE_SIZE = 10;

/**
 * Public web page for a single announcement.
 *
 * The list API no longer ships the HTML body, so a card can't expand in place —
 * tapping one opens the announcement on the website instead, the same way a
 * news or academy card opens its post.
 */
export const getAnnouncementUrl = (slug: string): string =>
  `${RABEX_BASE_URL}/announcements/${encodeURIComponent(slug)}`;
